import { inject, Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { shareReplay } from 'rxjs';

import { filterDefined } from '@recruitee/common';
import { fetchIfNotLoaded } from '@recruitee/ngrx';

import {
  TellentCurrentUserEntityActions,
  TellentCurrentUserSelectors,
} from './store/tellent-current-user.store';

@Injectable({
  providedIn: 'root',
})
export class TellentCurrentUserService {
  #store = inject(Store);

  public me$ = this.#store.pipe(
    fetchIfNotLoaded(this.#store.select(TellentCurrentUserSelectors.meta), () =>
      this.#store.dispatch(TellentCurrentUserEntityActions.fetch()),
    ),
    select(TellentCurrentUserSelectors.currentOrganizationMembershipSelectorSafe),
    filterDefined,
    shareReplay({ bufferSize: 1, refCount: true }),
  );
}
